export default __webpack_public_path__ + "static/media/birds.c8b2eee2.mp3";